import { ApolloLink } from './ApolloLink';

export const split = ApolloLink.split;
